import api from '~api'
import { convertPages } from '~utils/api'

export const url = `/faq-list`

export async function getFaqs (page) {
  const {
    data
  } = await api.get(`${url}`, {
    params: {
      page
    }
  })

  const faqs = data.data.map((faq) => {
    return {
      faq_id: faq.id,
      faq_question: faq.title,
      faq_answer: faq.content
    }
  })

  const pages = convertPages(data.meta)

  return ({
    faqs,
    pages
  })
}
